import type { ReactNode } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import styles from './AppDropdownMenu.module.scss';

export interface AppDropdownMenuItem {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  disabled?: boolean;
  destructive?: boolean;
}

export interface AppDropdownMenuProps {
  trigger: ReactNode;
  items: AppDropdownMenuItem[];
  align?: 'start' | 'center' | 'end';
}

export function AppDropdownMenu({ trigger, items, align = 'end' }: AppDropdownMenuProps) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>{trigger}</DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content className={styles.content} align={align} sideOffset={4}>
          {items.map((item) => (
            <DropdownMenu.Item
              key={item.label}
              className={item.destructive ? styles.itemDestructive : styles.item}
              disabled={item.disabled}
              onSelect={item.onClick}
            >
              {item.icon && <span className={styles.icon}>{item.icon}</span>}
              {item.label}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
